import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Content } from "../Components/Content";
import IconInfo from "@common/images/lighbulb.svg";
import { Icon } from "../Components/Icon";
import { TooltipWrapper } from "../Components/TootipWrapper";

/**
 * InfoTooltip:
 *   - Typically used to display info messages
 */
export function InfoTooltip(props) {
  const { title, className } = props;
  return (
    <TooltipWrapper className={`${style.infoTooltip} ${className}`}>
      <Icon icon={IconInfo} />
      <Content text={title} className={style.content} />
    </TooltipWrapper>
  );
}

InfoTooltip.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

InfoTooltip.defaultProps = {
  title: "",
  className: "",
};
